class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._closeTimer = null;

    // Hover-to-open — desktop + pointer devices only
    this._isHoverDesktop = window.matchMedia('(min-width: 990px) and (hover: hover)').matches;
    if (this._isHoverDesktop) {
      this.addEventListener('mouseenter', this._hoverOpen.bind(this));
      this.addEventListener('mouseleave', this._hoverClose.bind(this));
      // Click on summary navigates to the link's URL (since hover already opens the dropdown)
      const summary = this.mainDetailsToggle.querySelector('summary');
      const href = this.dataset.linkUrl || (summary && summary.dataset.navHref);
      if (summary && href && href !== '#' && href !== '') {
        summary.addEventListener('click', (e) => {
          // Allow modifier-clicks (Ctrl/Cmd/middle-click) to behave normally
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
          e.preventDefault();
          window.location.href = href;
        });
      }
    }
  }

  _hoverOpen() {
    clearTimeout(this._closeTimer);
    // Close any sibling that is already open
    document.querySelectorAll('header-menu').forEach((m) => {
      if (m !== this && m.mainDetailsToggle.hasAttribute('open')) m.close();
    });
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
    }
  }

  _hoverClose() {
    this._closeTimer = setTimeout(() => this.close(), 120);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
